import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { LiabilityStatusFilterValue } from '../../liabilities/models/model';

@Injectable({
  providedIn: 'root',
})
export class UrgentRedirectGuard implements CanActivate {
  constructor(private router: Router) {
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const navigationExtras = {
      state: { status: LiabilityStatusFilterValue.OVERDUE },
    };
    console.log(navigationExtras);
    return this.router.navigateByUrl('/liabilities/all', navigationExtras);
  }

}
